import { RETURN_REASON_MISSING_ACCEPT_TERMS_OF_RETURN_ERROR } from 'constants/returnReasons';
import Button from 'components/common/Button';
import ErrorFilledSmallIcon from 'components/common/IconsV2/ErrorFilledSmallIcon';
import { Alert } from 'components/common/Alert/Alert';
import { Checkbox } from 'components/common/Checkbox/Checkbox';

interface ReturnCostlyCustomerWarningProps {
  acceptTermsOfReturn?: boolean;
  onCheckTermsOfReturn: () => void;
  isReturnPreventingSubmitError?: boolean;
  returnErrorType?: string;
  returnPolicyUrl: string;
  cltLink: string;
  conditionsOfUse: string;
}

export default function ReturnCostlyCustomerWarning({
  acceptTermsOfReturn,
  onCheckTermsOfReturn,
  isReturnPreventingSubmitError,
  returnErrorType,
  returnPolicyUrl,
  conditionsOfUse
}: ReturnCostlyCustomerWarningProps) {
  return (
    <div className="flex flex-col gap-6">
      <Alert
        msg="This account has been flagged for activity that violates our return policy, and will no longer be eligible for instant refunds. Continued return policy violations may result in account closure."
        variant="warning"
        isDismissible={false}
      />
      <div>
        <h3 className="text-xl font-semibold">Return Items</h3>
        <div>
          <div className="pb-2 pt-3">
            <Checkbox
              checked={acceptTermsOfReturn}
              onClick={onCheckTermsOfReturn}
              label={
                (
                  <span>
                    By checking this box, in addition to the{' '}
                    <Button size="small" variant="text" href={conditionsOfUse}>
                      Zappos Conditions of Use
                    </Button>
                    , you agree to the following terms for your return:
                  </span>
                ) as any
              }
            />
          </div>
          {isReturnPreventingSubmitError && returnErrorType === RETURN_REASON_MISSING_ACCEPT_TERMS_OF_RETURN_ERROR && (
            <div className="flex items-center gap-1">
              <ErrorFilledSmallIcon size={16} color="#C0000A" />
              <p className="text-sm text-alert-inline">Please agree to the return terms</p>
            </div>
          )}
        </div>
        <ul className="list-disc gap-2 pl-10 pt-2">
          <li>If merchandise is incorrect or defective, contact us before making a return.</li>
          <li>Refunds are initiated once Zappos processes the return (up to 30 business days after drop-off with mail carrier).</li>
          <li>
            <Button height="small" size="small" variant="text" href={returnPolicyUrl}>
              Terms and Conditions
            </Button>
          </li>
        </ul>
      </div>
    </div>
  );
}
